<div class="all-page-combo-layout">
  <div class="all-page-feed">
    <app-bussiness-post [postView]="'TEAM'"></app-bussiness-post>
  </div>
  <div class="all-page-widget">
    <app-common-widget [page]="'TEAMS_HOME_PAGE'" [inputData]="'TEAM'"></app-common-widget>
  </div>
</div>